import { createTheme, ThemeProvider } from "@mui/material";
import React from "react";
export const BusTheme = createTheme({
  palette: {
    primary: {
      light: "#7986cb",
      main: "rgb(130, 192, 71)",
      dark: "rgb(130, 192, 71)",
      contrastText: "#fff",
    },
    secondary: {
      light: "#ff4081",
      main: "#000",
      dark: "#097840",
      contrastText: "#fff",
    },
    error: {
      main: "#9D0009",
    },
  },
});
export const BusThemeProvider = (props) => {
  return <ThemeProvider theme={BusTheme}>{props.children}</ThemeProvider>;
};
